import React from 'react';
import { ClockIcon, HeartPulseIcon, LeafIcon, ShoppingCartIcon, SmileIcon, SparklesIcon } from 'lucide-react';
const benefits = [{
  icon: ClockIcon,
  title: 'Recupera tus horas',
  text: 'Cocina toda la semana en solo 2 horas.'
}, {
  icon: HeartPulseIcon,
  title: 'Alimentación real',
  text: 'Comidas saludables, nutritivas y deliciosas.'
}, {
  icon: ShoppingCartIcon,
  title: 'Compra mejor',
  text: 'Aprende a ahorrar hasta un 45% en el supermercado.'
}, {
  icon: SparklesIcon,
  title: 'Menos decisiones',
  text: 'Deja atrás el estrés de pensar qué cocinar cada día.'
}, {
  icon: LeafIcon,
  title: 'Rutina en orden',
  text: 'Tu semana organizada, sin desperdiciar alimentos.'
}, {
  icon: SmileIcon,
  title: 'Tiempo para vivir',
  text: 'Disfruta más momentos para ti y tu familia.'
}];
export function BenefitsSection() {
  return <section id="beneficios" className="bg-[#fffaf0] px-5 py-16 sm:px-8 sm:py-24" data-id="element-17" data-mp="12yk4e76dz3sz">
      <div className="mx-auto max-w-7xl" data-id="element-18" data-mp="2bdmg73u8ph23">
        <div className="max-w-2xl" data-id="element-19" data-mp="27dkckp4y2dk6">
          <p className="text-sm font-bold uppercase tracking-[0.16em] text-[#a92d3d]" data-id="element-20" data-mp="27cj32p3ktz4k">
            Tu nueva rutina
          </p>
          <h2 className="font-display mt-4 text-4xl font-black leading-[0.98] tracking-[-0.045em] text-[#143827] sm:text-5xl" data-id="element-21" data-mp="2l47awg6sm1fq">
            ✨ Más que recetas: una semana que fluye mejor.
          </h2>
        </div>
        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-22" data-mp="1sie8w8tbmqu0">
          {benefits.map(({
          icon: Icon,
          title,
          text
        }) => <article key={title} className="rounded-2xl border border-[#e8dcc3] bg-white p-6" data-id="element-23" data-mp="22f0r0pu9j3sc">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#e8f0df] text-[#2f704a]" data-id="element-24" data-mp="1xdtiupo7k2l5">
                <Icon aria-hidden="true" className="h-5 w-5" data-id="element-25" data-mp="3dvr1il5pyhrr" />
              </span>
              <h3 className="mt-5 text-lg font-extrabold text-[#173d2a]" data-id="element-26" data-mp="38u1mkufdljye">
                {title}
              </h3>
              <p className="mt-2 leading-relaxed text-[#5d6e61]" data-id="element-27" data-mp="3gxc0f5pu9lgy">{text}</p>
            </article>)}
        </div>
      </div>
    </section>;
}